// The EU/EEA member states plus the UK, which has its own GDPR. Kept in the app rather than in a
// shared library because it is a policy list about which privacy regime governs a session, and the
// CMP that owns that question lives here.
//
// Used only for the pre-consent window. Once the CMP answers, its `gdprApplies` is authoritative
// and supersedes anything derived from the country.
const GDPR_COUNTRY_CODES = new Set([
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  // EEA, non-EU
  'IS',
  'LI',
  'NO',
  // UK GDPR
  'GB',
]);

/**
 * Whether the GDPR regime governs a session in this country.
 *
 * Returns `undefined` when the country is unresolved, so callers can tell "not GDPR" apart from
 * "not known yet" and fail closed on the latter.
 */
export function isGdprCountry(countryCode?: string): boolean | undefined {
  if (!countryCode) {
    return undefined;
  }

  return GDPR_COUNTRY_CODES.has(countryCode.toUpperCase());
}
